export default function Facebook({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.048"
      height="25"
      viewBox="0 0 13.048 25"
      {...props}
    >
      <path d="M12.8.082 9.139 0a5.366 5.366 0 0 0-5.484 5.364v3.472h-3.4a.253.253 0 0 0-.253.253v4.363a.253.253 0 0 0 .253.253h3.4v11.04a.253.253 0 0 0 .253.253h4.5a.253.253 0 0 0 .253-.253v-11.04h3.43a.253.253 0 0 0 .251-.22l.567-4.363a.253.253 0 0 0-.251-.286h-4V6.633a2.519 2.519 0 0 1 .465-1.683 1.374 1.374 0 0 1 1.078-.42h2.588a.253.253 0 0 0 .253-.253V.333A.253.253 0 0 0 12.8.082Z" />
    </svg>
  );
}
